/**
 * Author: postcodex
 * Date: 10/7/20
 * Time: 10:49 AM
 */
import React from 'react';

const Loading = ( props ) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={ { margin : 0, background : 'transparent', display : 'inline-block' } }
			width="32px"
			height="32px"
			viewBox="0 0 100 100"
			preserveAspectRatio="xMidYMid"
		>
			<rect x="0" y="30" width="10" height="40" fill="#353535">
				<animate
					attributeName="opacity" dur="2s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1"
					keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1" begin="-1.2"
				/>
			</rect>
			<rect x="20" y="30" width="10" height="40" fill="#666666">
				<animate
					attributeName="opacity" dur="2s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1"
					keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1" begin="-0.8"
				/>
			</rect>
			<rect x="40" y="30" width="10" height="40" fill="#9b9b9b">
				<animate
					attributeName="opacity" dur="2s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1"
					keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1" begin="-0.4"
				/>
			</rect>
			<rect x="60" y="30" width="10" height="40" fill="#d4d4d4">
				<animate
					attributeName="opacity" dur="2s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1"
					keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1" begin="-2"
				/>
			</rect>
			<rect x="80" y="30" width="10" height="40" fill="#e3e3e3">
				<animate
					attributeName="opacity" dur="2s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1"
					keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1" begin="-2"
				/>
			</rect>
		</svg>
	);
};

Loading.propTypes = {};

Loading.defaultProps = {};

export default Loading;
